export default __webpack_public_path__ + "1.17.11/static/media/close.b1d40998.svg";